import {
  MdPayments,
  MdCurrencyExchange,
  MdCategory,
  MdQuestionAnswer,
  MdQuestionMark,
  MdOutlineQuestionAnswer,
  MdApproval,
  MdOutlineSubscriptions,
} from "react-icons/md";
import { FaHome, FaWallet, FaMoneyBill, FaTools } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import constant from "../../utils/constant";
import {
  AiFillReconciliation,
  AiFillBank,
  AiOutlineTransaction,
} from "react-icons/ai";
import { AiOutlineCustomerService } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import React from "react";
import {
  RiAdminLine,
  RiPaintBrushFill,
  RiSecurePaymentFill,
} from "react-icons/ri";
import { GiPayMoney } from "react-icons/gi";
import { CiMoneyCheck1, CiBank } from "react-icons/ci";
import { FcFeedback } from "react-icons/fc";
import { VscFeedback } from "react-icons/vsc";
import { BsHourglassSplit } from "react-icons/bs";
import { SiStylelint, SiBookstack } from "react-icons/si";
import { GiReceiveMoney } from "react-icons/gi";
import { FaPerson } from "react-icons/fa6";
import { FaPersonWalkingArrowLoopLeft } from "react-icons/fa6";
import { FaNewspaper } from "react-icons/fa6";
import { GiSatelliteCommunication } from "react-icons/gi";
import { GiBank } from "react-icons/gi";
import { IoIosBusiness } from "react-icons/io";
import { BiCategoryAlt } from "react-icons/bi";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { RiAdvertisementFill } from "react-icons/ri";
import { PiUsersThree } from "react-icons/pi";
import { BsCurrencyExchange } from "react-icons/bs";
import { FcCurrencyExchange } from "react-icons/fc";
import { GiSettingsKnobs } from "react-icons/gi";
import { PiContactlessPaymentBold } from "react-icons/pi";

export const SidebarData = [
  {
    title: "Dashboard",
    // module: 'BUSINESS ADMIN',
    type: "GENERAL",
    icon: <FaHome />,
    link: constant.Routes.AdminDashboard,
  },
  {
    title: "Signed-Up-Businesses",
    module: "BUSINESS DETAILS",
    type: "GENERAL",
    icon: <MdPayments />,
    link: constant.Routes.SignedUpBusineses,
  },
  {
    title: "Subscriptions",
    icon: <MdOutlineSubscriptions />,
    type: "GENERAL",
    link: constant.Routes.Subscription,
  },
  {
    title: "Wallet",
    module: "WALLET",
    type: "GENERAL",
    icon: <FaWallet />,
    link: constant.Routes.Wallet,
    subNav: [
      {
        title: "All Wallets",
        type: "GENERAL",
        icon: <FaWallet />,
        link: constant.Routes.Wallet,
        module: "WALLET",
      },
      {
        title: "Create Inflow",
        type: "GENERAL",
        icon: <GiReceiveMoney />,
        link: constant.Routes.CreateInflow,
        module: "WALLET",
      },
      {
        title: "Create Outflow",
        type: "GENERAL",
        icon: <GiPayMoney />,
        link: constant.Routes.CreateOutflow,
        module: "WALLET",
      },
      {
        title: "Approve Bank Account",
        type: "GENERAL",
        icon: <MdApproval />,
        link: constant.Routes.ApproveBank,
        module: "WALLET",
      },
      {
        title: "Bank Accounts List",
        type: "GENERAL",
        icon: <AiFillBank />,
        link: constant.Routes.BankAccountList,
        module: "WALLET",
      },
      {
        title: "Foreign Bank Accounts",
        type: "GENERAL",
        icon: <GiBank />,
        link: constant.Routes.ForeignBankAccounts,
        module: "WALLET",
      },
    ],
  },
  {
    title: "Exchange",
    module: "EXCHANGE",
    type: "GENERAL",
    icon: <MdCurrencyExchange />,
    link: constant.Routes.ExchangeRate,
    subNav: [
      {
        title: "Exchange-Rate",
        module: "EXCHANGE",
        type: "GENERAL",
        icon: <MdCurrencyExchange />,
        link: constant.Routes.ExchangeRate,
      },
      {
        title: "Exchange-Transactions",
        // module: 'TRANSACTION',
        type: "GENERAL",
        icon: <AiOutlineTransaction />,
        link: constant.Routes.ExchangeTransactions,
      },
    ],
  },
  {
    title: "Transactions",
    module: "TRANSACTION",
    type: "GENERAL",
    icon: <MdPayments />,
    link: constant.Routes.Transaction,
    subNav: [
      {
        title: "All Transactions",
        module: "TRANSACTION",
        type: "GENERAL",
        icon: <MdPayments />,
        link: constant.Routes.Transaction,
      },
      {
        title: "Kuda Transactions",
        module: "Kuda Transactions",
        type: "GENERAL",
        icon: <CiBank />,
        link: constant.Routes.KudaTransactions,
      },
      {
        title: "Providus Transactions",
        module: "Providus Transactions",
        type: "GENERAL",
        icon: <CiBank />,
        link: constant.Routes.ProvidusTransactions,
      },
    ],
  },

  {
    title: "Money-Ex",
    // module: "EXCHANGE",
    type: "GENERAL",
    icon: <FaMoneyCheckDollar />,
    link: constant.Routes.MoneyExAds,
    subNav: [
      {
        title: "Money-Ex Limit",
        // module: "EXCHANGE",
        type: "GENERAL",
        icon: <GiSettingsKnobs />,
        link: constant.Routes.MoneyExLimit,
      },
      {
        title: "Money-Ex Ads",
        // module: "EXCHANGE",
        type: "GENERAL",
        icon: <RiAdvertisementFill />,
        link: constant.Routes.MoneyExAds,
      },
      {
        title: "Money-Ex Users",
        // module: "EXCHANGE",
        type: "GENERAL",
        icon: <PiUsersThree />,
        link: constant.Routes.MoneyExUsers,
      },
      {
        title: "Money-Ex P2P Orders",
        // module: "EXCHANGE",
        type: "GENERAL",
        icon: <BsCurrencyExchange />,
        link: constant.Routes.MoneyExP2POrders,
      },
      {
        title: "Money-Ex Express Orders",
        // module: "EXCHANGE",
        type: "GENERAL",
        icon: <FcCurrencyExchange />,
        link: constant.Routes.MoneyExExpressOrders,
      },
    ],
  },
  {
    title: "Fash Creatives",
    type: "GENERAL",
    icon: <SiStylelint />,
    link: constant.Routes.FashCreatives,
    subNav: [
      {
        title: "Fash Businesses",
        type: "GENERAL",
        icon: <IoIosBusiness />,
        link: constant.Routes.FashBusinesses,
      },
      {
        title: "Public Catalogue",
        type: "GENERAL",
        icon: <SiBookstack />,
        link: constant.Routes.FashPublicCatalogue,
      },
      {
        title: "Style Categories",
        type: "GENERAL",
        icon: <BiCategoryAlt />,
        link: constant.Routes.StyleCategories,
      },
      {
        title: "All Marketers",
        type: "GENERAL",
        icon: <FaPerson />,
        link: constant.Routes.Marketers,
      },
      {
        title: "Marketers Analysis",
        type: "GENERAL",
        icon: <FaPersonWalkingArrowLoopLeft />,
        link: constant.Routes.MarketersAnalysis,
      },
      {
        title: "Partner Payout",
        type: "GENERAL",
        icon: <RiSecurePaymentFill />,
        link: constant.Routes.Payout,
      },
      {
        title: "Themes",
        type: "GENERAL",
        icon: <RiPaintBrushFill />,
        link: constant.Routes.Themes,
      },
    ],
  },
  {
    title: "Competition",
    // module: 'FAQs',
    type: "GENERAL",
    icon: <MdQuestionAnswer />,
    link: constant.Routes.Competitions,
    subNav: [
      {
        title: "Competitions",
        type: "GENERAL",
        icon: <MdQuestionMark />,
        link: constant.Routes.Competitions,
      },
      {
        title: "Participants",
        type: "GENERAL",
        icon: <MdOutlineQuestionAnswer />,
        link: constant.Routes.Participants,
      },
      {
        title: "Votes",
        type: "GENERAL",
        icon: <MdOutlineQuestionAnswer />,
        link: constant.Routes.Votes,
      },
    ],
  },
  {
    title: "Admin Control",
    module: "ADMIN",
    type: "GENERAL",
    icon: <RiAdminLine />,
    link: constant.Routes.Admin,
  },
  {
    title: "Audit / Activity Tracking",
    // module: 'ADMIN',
    type: "GENERAL",
    icon: <RiAdminLine />,
    link: constant.Routes.Audit,
  },
  {
    title: "Bills",
    module: "BILL PAYMENT",
    type: "GENERAL",
    icon: <FaMoneyBill />,
    link: constant.Routes.Bills,
    subNav: [
      {
        title: "All Bills",
        module: "BILL PAYMENT",
        type: "GENERAL",
        icon: <FaMoneyBill />,
        link: constant.Routes.Bills,
      },
      {
        title: "Reconcile Bills",
        module: "BILL PAYMENT",
        type: "GENERAL",
        icon: <AiFillReconciliation />,
        link: constant.Routes.ReconcileBills,
      },
    ],
  },
  {
    title: "Broadcast",
    // module: "ADMIN",
    type: "GENERAL",
    icon: <GiSatelliteCommunication />,
    link: constant.Routes.Broadcast,
  },
  {
    title: "Business Category",
    icon: <MdCategory />,
    type: "GENERAL",
    link: constant.Routes.BusinessCategory,
  },
  {
    title: "Charge",
    module: "CHARGE",
    type: "GENERAL",
    icon: <CiMoneyCheck1 />,
    link: constant.Routes.Charge,
    subNav: [
      {
        title: "All Charges",
        module: "CHARGE",
        type: "GENERAL",
        icon: <CiMoneyCheck1 />,
        link: constant.Routes.Charge,
      },
      {
        title: "Charge Analysis",
        icon: <MdCategory />,
        type: "GENERAL",
        link: constant.Routes.ChargeAnalysis,
      },
    ],
  },
  {
    title: "Expense Category",
    icon: <MdCategory />,
    type: "GENERAL",
    link: constant.Routes.ExpenseCategory,
  },
  {
    title: "FAQs",
    // module: 'FAQs',
    type: "GENERAL",
    icon: <MdQuestionAnswer />,
    link: constant.Routes.Faqs,
    subNav: [
      {
        title: "All FAQs",
        // module: 'FAQs',
        type: "GENERAL",
        icon: <MdQuestionMark />,
        link: constant.Routes.Faqs,
      },
      {
        title: "FAQ Category",
        module: "FAQs",
        type: "GENERAL",
        icon: <MdOutlineQuestionAnswer />,
        link: constant.Routes.FaqsCategory,
      },
    ],
  },

  {
    title: "Feedback",
    type: "GENERAL",
    icon: <FcFeedback />,
    link: constant.Routes.FeedbackRes,
    subNav: [
      {
        title: "Feedback Response",
        type: "GENERAL",
        icon: <FcFeedback />,
        link: constant.Routes.FeedbackRes,
      },
      {
        title: "Feedback Configuration",
        type: "GENERAL",
        icon: <VscFeedback />,
        link: constant.Routes.FeedbackConfig,
      },
    ],
  },
  {
    title: "News",
    // module: "ADMIN",
    type: "GENERAL",
    icon: <FaNewspaper />,
    link: constant.Routes.News,
  },
  {
    title: "Payment Method",
    // module: "INVOICE/RECEIPT",
    icon: <PiContactlessPaymentBold />,
    link: constant.Routes.PaymentMethod,
  },
  {
    title: "Prospects",
    // module: "INVOICE/RECEIPT",
    icon: <AiOutlineCustomerService />,
    link: constant.Routes.Prospects,
  },
  {
    title: "Providers",
    // module: 'ADMIN',
    type: "GENERAL",
    icon: <FaTools />,
    link: constant.Routes.Providers,
  },
  {
    title: "Split Payment",
    // module: 'ADMIN',
    type: "GENERAL",
    icon: <BsHourglassSplit />,
    link: constant.Routes.SplitPayment,
  },
  {
    title: "Support",
    icon: <BiSupport />,
    type: "GENERAL",
    link: constant.Routes.Support,
  },
  {
    title: "Settings",
    icon: <IoMdSettings />,
    type: "GENERAL",
    link: constant.Routes.Settings,
  },
];
